import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginNavService {

  private topNavDataSubject = new BehaviorSubject<any>(null);
  private sideNavDataSubject = new BehaviorSubject<any>(null);

  topNavData$: Observable<any> = this.topNavDataSubject.asObservable();
  sideNavData$: Observable<any> = this.sideNavDataSubject.asObservable();

  constructor() { }

  setTopNavData(data: any): void {
    this.topNavDataSubject.next(data);
  }

  setSideNavData(data: any): void {
    this.sideNavDataSubject.next(data);
  }

}
